import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { SESSION_STORAGE_CONSTS } from "../constants";

const MSO_URL = process.env.REACT_APP_MSO_ENV_APP_URL;

function useMSOAppData() {
  const [applicationId, setApplicationId] = useState<string | null>();
  const [callbackUrl, setCallbackUrl] = useState<string | null>();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // get applicationId and callbackUrl & save in session storage to preserve through re-rendering
  useEffect(() => {
    const sessionApplicationId = window.sessionStorage.getItem(
      SESSION_STORAGE_CONSTS.APPLICATION_ID
    );
    const sessionCallbackUrl = window.sessionStorage.getItem(
      SESSION_STORAGE_CONSTS.CALLBACK_URL
    );

    // if session storage has already been set, we don't need to reset these values
    // use case: when a user resets their password and then signs in again or SSO flow
    if (sessionApplicationId && sessionCallbackUrl) {
      setApplicationId(sessionApplicationId);
      setCallbackUrl(sessionCallbackUrl);
    }

    // otherwise, try to get the data from the URL query params
    // use case: user visits the sign in page for the first time
    const applicationParam = searchParams.get("application");
    const callbackParam = searchParams.get("callback");

    if (applicationParam && callbackParam) {
      setApplicationId(applicationParam);
      setCallbackUrl(callbackParam);
    }

    if (applicationParam) {
      window.sessionStorage.setItem(
        SESSION_STORAGE_CONSTS.APPLICATION_ID,
        applicationParam
      );
    }

    if (callbackParam) {
      window.sessionStorage.setItem(
        SESSION_STORAGE_CONSTS.CALLBACK_URL,
        callbackParam
      );
    }

    // last option is to default the values to MSO app & MSO dashboard
    if (!sessionApplicationId && !applicationParam) {
      window.sessionStorage.setItem(
        SESSION_STORAGE_CONSTS.APPLICATION_ID,
        "MSO"
      );
      setApplicationId("MSO");
    }

    if (!sessionCallbackUrl && !callbackParam) {
      window.sessionStorage.setItem(
        SESSION_STORAGE_CONSTS.CALLBACK_URL,
        `${MSO_URL}`
      );
      setCallbackUrl(`${MSO_URL}`);
    }
  }, [searchParams, navigate, applicationId, callbackUrl]);

  return { applicationId, callbackUrl };
}

export default useMSOAppData;
